module.exports = __webpack_public_path__ + "img/maquette-orbitale.0935136a.svg";